import { Core } from "@faire/design-tokens";
import { Opacity } from "@faire/web/slate/Color";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { TypographyStyles } from "@faire/web/slate/Typography";
import styled from "styled-components";

const RESULTS_DROPDOWN_SECTIONS_WRAPPER_PADDING_TOP = getSpacing("1x");
const RESULTS_DROPDOWN_SECTION_HEADER_WRAPPER_PADDING_BOTTOM = getSpacing("1x");

export const InfoWrapper = styled(Column).attrs({ justify: "space-between" })`
  flex: 1;
  min-width: 0;
  padding: ${getSpacing(0, 0, 0, "2x")};
  width: 100%;
`;

export const ResultsDropdownView = styled.div<{
  $top: number;
  $width?: number;
  $height?: number;
}>`
  max-height: 93vh;
  ${responsiveMediaQueries.mobile} {
    height: 100vh;
  }
  background: ${Core.surface.inverse};
  z-index: 500;
  ${TypographyStyles({ as: undefined })}

  position: absolute;
  top: ${(props) => props.$top}px;
  width: ${(props) => props.$width}px;

  overflow-y: auto;
  box-shadow: 0 1px 1px 0px ${Core.surface.subdued};

  h5 {
    margin: 4px 0 0 18px !important;
    ${TypographyStyles({ as: undefined })}
  }

  > div:first-of-type h5 {
    margin-top: 0;
  }

  strong {
    ${TypographyStyles({ truncate: true, variant: "paragraphSansMedium" })}
    min-width: 0;
  }

  span {
    ${TypographyStyles({ truncate: true })}
    min-width: 0;
  }

  > div:last-of-type {
    padding-top: ${RESULTS_DROPDOWN_SECTIONS_WRAPPER_PADDING_TOP};
  }

  box-shadow: 0 7px 10px ${Core.surface.enabled + Opacity.O_10};

  @media screen and (max-width: 767px) {
    top: ${(props) => props.$height}px;
    left: 0;
    right: 0;
    width: auto;
    bottom: 0;
  }
`;

export const ResultsDropdownSectionsWrapper = styled.div`
  padding-top: ${RESULTS_DROPDOWN_SECTIONS_WRAPPER_PADDING_TOP};
`;

export const ResultsDropdownSectionHeaderWrapper = styled(Row)`
  padding-bottom: ${RESULTS_DROPDOWN_SECTION_HEADER_WRAPPER_PADDING_BOTTOM};
`;
